import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Header from "../../layout/Header";
import BannerSimple from "../../layout/BannerSimple";
import Footer from "../../layout/Footer";
import ListOption from "../../layout/ListOption";
import Loading from "../../layout/Loading";
import publicApi from "../../../utils/publicApi";

import Stage1 from "./Stage1";
import Stage2 from "./Stage2";
import StageDetail from "./StageDetail";

/**
 * Pages de stage, alimentées par l'entité `Stage` de la base.
 *
 * La liste et les en-têtes viennent de l'API : ajouter un stage dans l'admin
 * suffit pour qu'il apparaisse ici. Les deux premières sessions gardent leur
 * page écrite à la main, plus riche que ce que le modèle sait stocker ; les
 * suivantes sont rendues par `StageDetail` depuis leurs champs.
 *
 * Le paramètre d'URL accepte les deux formes : le slug (`/stage/stage-3`, celle
 * qu'émet le sitemap) et l'ancien numéro (`/stage/1`), pour ne pas casser les
 * liens déjà en circulation.
 */

const PAGES_DEDIEES = {
	"stage-1": Stage1,
	"stage-2": Stage2,
};

const ICONES = ["lnr-book", "lnr-keyboard", "lnr-laptop-phone", "lnr-code", "lnr-briefcase"];

class Stage extends Component {

	constructor(props) {
		super(props);
		this.state = { stages: [], loading: true, error: null };
	}

	componentDidMount() {
		this.chargerStages();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.session !== this.props.match.params.session) {
			window.scrollTo(0, 0);
			this.definirTitre();
		}
	}

	chargerStages = async () => {
		try {
			const reponse = await publicApi.get("/api/stages");
			this.setState(
				{ stages: reponse.data?.stages || [], loading: false },
				this.definirTitre,
			);
		} catch (error) {
			console.error("Error loading stages:", error);
			this.setState({ stages: [], loading: false, error: "Impossible de charger les stages." });
		}
	};

	/** Le stage demandé, par slug ou par ancien numéro d'ordre. */
	stageCourant() {
		const { session } = this.props.match.params;
		if (!session) return null;

		const parSlug = this.state.stages.find((s) => s.slug === session);
		if (parSlug) return parSlug;

		// Anciens liens numériques : `stage-3`, puis à défaut l'ordre affiché,
		// qui ne coïncide pas forcément avec le numéro du slug.
		const parConvention = this.state.stages.find((s) => s.slug === `stage-${session}`);
		if (parConvention) return parConvention;

		return this.state.stages.find((s) => String(s.order) === String(session)) || null;
	}

	definirTitre = () => {
		const stage = this.stageCourant();
		document.title = `${stage ? stage.title : "Stages"} - ${window.APP_NAME}`;
		window.resetScript();
	};

	filAriane(dernier) {
		return [
			{ name: "Accueil", link: "/" },
			{ name: "Stage", link: "/stage" },
			{ name: dernier, link: window.location.pathname },
		];
	}

	renderListe() {
		const { stages, loading, error } = this.state;

		if (loading) {
			return (
				<div className="service-area section-gap white">
					<div className="container">
						<Loading variant="dots" size="medium" color="primary" text="Chargement des stages..." />
					</div>
				</div>
			);
		}

		return (
			<ListOption
				title="Stage"
				description={ error || "Cette section présente mes travaux de stages." }
				list={ stages.map((stage, i) => ({
					title: `${stage.title.replace(/^Stage\s+/i, "")} (${stage.period})`,
					description: stage.description || `Stage effectué chez ${stage.company}.`,
					link: `/stage/${stage.slug}`,
					lnr_icon: ICONES[i % ICONES.length],
				})) }
			/>
		);
	}

	renderDetail(stage) {
		const PageDediee = PAGES_DEDIEES[stage.slug];
		return (
			<>
				<BannerSimple title={ stage.title } boxElement={ this.filAriane(stage.title) } />
				{ PageDediee ? <PageDediee /> : <StageDetail stage={ stage } /> }
			</>
		);
	}

	render() {
		const { session } = this.props.match.params;
		const { loading } = this.state;
		const stage = this.stageCourant();

		let contenu;
		if (session && loading) {
			// On attend les données avant de trancher entre détail et liste,
			// sinon une session valide s'afficherait une fraction de seconde
			// comme introuvable.
			contenu = (
				<>
					<BannerSimple title="Stage" boxElement={ this.filAriane("Stage") } />
					<div className="service-area section-gap white">
						<div className="container">
							<Loading variant="dots" size="medium" color="primary" text="Chargement du stage..." />
						</div>
					</div>
				</>
			);
		} else if (stage) {
			contenu = this.renderDetail(stage);
		} else {
			contenu = (
				<>
					<BannerSimple title="Stage" boxElement={ [{ name: "Accueil", link: "/" }, { name: "Stage", link: window.location.pathname }] } />
					{ this.renderListe() }
				</>
			);
		}

		return (
			<>
				<Header active="Stage" modeDark={ true } />
				{ contenu }
				<Footer />
			</>
		);
	}
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(withRouter(Stage));
